import en from './en.json';
import uk from './uk.json';

const messages = {
  en: en,
  uk: uk,
};

export default messages;
